export default __webpack_public_path__ + "static/media/Facebook.62a9c699.png";